/**
 * Export `dateToString`.
 */

export function dateToString(date: Date, locale: string) {
  return date.toLocaleString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}
